export default __webpack_public_path__ + "static/media/GMCBG.dd5e7104.png";